module.exports = __webpack_public_path__ + "img/2.f06174b2.png";